import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=18b8d708&"
import script from "./Layout.vue?vue&type=script&setup=true&lang=js&"
export * from "./Layout.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Layout.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports